import { createContext, useContext, useState, useEffect } from "react";

const RoleContext = createContext(null);

export const ROLES = {
  TRAVELER: "traveler",
  ADMIN: "admin",
  NONE: null,
};

export function RoleProvider({ children }) {
  const [role, setRole] = useState(() => localStorage.getItem("carrey_role") || null);
  const [travelerName, setTravelerName] = useState(() => localStorage.getItem("carrey_traveler_name") || "");
  const [activeTripId, setActiveTripId] = useState(() => localStorage.getItem("carrey_trip_id") || null);

  useEffect(() => {
    if (role) localStorage.setItem("carrey_role", role);
    else localStorage.removeItem("carrey_role");
  }, [role]);

  useEffect(() => {
    if (travelerName) localStorage.setItem("carrey_traveler_name", travelerName);
  }, [travelerName]);

  useEffect(() => {
    if (activeTripId) localStorage.setItem("carrey_trip_id", activeTripId);
    else localStorage.removeItem("carrey_trip_id");
  }, [activeTripId]);

  return (
    <RoleContext.Provider value={{ role, setRole, travelerName, setTravelerName, activeTripId, setActiveTripId }}>
      {children}
    </RoleContext.Provider>
  );
}

export const useRole = () => useContext(RoleContext);
